<template>
    <div class="container-fluid">
        <div>
            <div class="text-center">
                <h5>Acompanhamento de atividades</h5>
            </div>
            <div>
                <span>Período</span>
                <div class="row task-made-form">
                    <div class="form-group col-md-1">
                        <date-picker
                            v-model ="filters.startDate"
                            format="DD/MM/YY"
                            v-mask="'##/##/##'"
                            v-on:change="builderFilters"
                        >
                        </date-picker>
                    </div>
                    <div class="form-group col-md-1">
                        <date-picker
                            v-model ="filters.endDate"
                            format="DD/MM/YY"
                            v-mask="'##/##/##'"
                            v-on:change="builderFilters"
                        >
                        </date-picker>
                    </div>
                    <div class="form-group col-md-1">
                        <button v-on:click="clearFilters" class="form-control btn btn-danger">Limpar</button>
                    </div>
                </div>
            </div>


            <div v-if="loading" class="text-center loading-tasks"><i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i></div>

            <div v-else>
                <table class="table table-striped users-table">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>realizado</th>
                        <th>potencial</th>
                        <th>%</th>
                        <th class="text-center" width="200px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td>{{ user.name }}</td>
                        <td>{{ secondsToDate(user.workload.worked_total) }}</td>
                        <td>{{ secondsToDate(user.workload.workload_total) }}</td>
                        <td>{{ Math.abs(user.workload.percentage_worked).toFixed(2) }} %</td>
                        <td>
                            <div class="progress">
                                <div class="progress-bar text-shadow" role="progressbar"
                                     :style="'width:'+user.workload.percentage_worked+'%; background-color:'+((user.workload.workload_total - user.workload.tolerance > user.workload.worked_total) ? 'red':'green')"
                                >
                                    {{ Math.abs(user.workload.percentage_worked).toFixed(2) }} %
                                </div>

                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'TasksMadeUsersWorked',
        data () {
            return {
                loading: false,
                users: {},
                search: '',
                deletedUsers: {},
                stringFilters: null,
                loadStringFilters: false,
                filters: {
                    startDate: new Date (),
                    endDate: new Date ()
                }
            }
        },
        components: {
            DatePicker
        },
        mounted (){
            this.index()
            this.loadFilters()
        },
        methods: {
            index () {
                if (!this.stringFilters) {

                    this.stringFilters = 'startDate=' + this.formatDate(this.filters.startDate) + '&endDate=' + this.formatDate(this.filters.endDate)
                }
                this.loading = true
                axios
                    .get('/api/tasks_made/worked_users?' + this.stringFilters)
                    .then((response) => {
                        this.users = response.data
                        this.loading = false
                    })
            },
            formatDate (date) {
                return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
            },
            formatDateBr (date) {
                return (("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear());
            },
            secondsToDate (seconds) {
                if (isNaN(seconds)) {
                    return '00:00:00'
                }
                let hours = Math.floor(seconds / 3600)
                seconds %= 3600
                let minutes = Math.floor(seconds / 60)
                seconds = seconds % 60

                return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
            },
            loadFilters () {
                this.filters = {
                    startDate: new Date (),
                    endDate: new Date ()
                }
            },
            builderFilters () {
                let filters = {
                    startDate: this.formatDate(this.filters.startDate),
                    endDate: this.formatDate(this.filters.endDate)
                }
                this.builderFiltersString(filters)
            },
            builderFiltersString (filters) {
                let filterString = ''
                for (let filter in filters) {
                    if (filters[filter] != null) {
                        filterString += filter + '=' + filters[filter] + '&'
                    }
                }
                this.stringFilters = filterString.substring(0, filterString.length - 1)
                this.index()
                this.loadStringFilters = true
            },
            clearFilters () {
                this.stringFilters = ''
                this.loadFilters()
                this.index()
                this.loadStringFilters = false
            }
        }
    }
</script>

<style scoped lang="sass">
    .loading-tasks
        font-size: 50px
        margin-top: 200px
    .search
        margin-top: 15px
        border-top: 1px solid #3c3c3c
        padding: 15px 0

    .btn-create
        float: right

    .users-table
        td
            a
                padding: 0
</style>
